import { MARKETING_NAME } from '../../support/brand';
import { COMPANY_CNPJ, COMPANY_NAME, COMPANY_EMAIL } from '../../support/legal';
import { FONT_HREF, FONT_ID } from '../../support/maiaFonts';
import { PANEL_URL } from '../../support/publicUrls';
import { SAME_AS_LINKS } from '../../support/social';
import { FAQS, LANDING_MARKDOWN_URL, LANDING_URL, LAST_MODIFIED, SEO } from './content';

export const SOCIAL_IMAGE_URL = `${PANEL_URL}/images/social/maia-mentor.png`;
const SOCIAL_IMAGE_ALT = 'MAIA — mentoria digital no WhatsApp';

export const META_TAGS = [
  ['meta', { name: 'description', content: SEO.description }],
  [
    'meta',
    { name: 'robots', content: 'index, follow, max-snippet:-1, max-image-preview:large' },
  ],
  ['meta', { property: 'og:type', content: 'website' }],
  ['meta', { property: 'og:locale', content: 'pt_BR' }],
  ['meta', { property: 'og:title', content: SEO.title }],
  ['meta', { property: 'og:description', content: SEO.description }],
  ['meta', { property: 'og:url', content: SEO.canonical }],
  ['meta', { property: 'og:image', content: SOCIAL_IMAGE_URL }],
  ['meta', { property: 'og:image:width', content: '1200' }],
  ['meta', { property: 'og:image:height', content: '630' }],
  ['meta', { property: 'og:image:alt', content: SOCIAL_IMAGE_ALT }],
  ['meta', { name: 'twitter:card', content: 'summary_large_image' }],
  ['meta', { name: 'twitter:title', content: SEO.title }],
  ['meta', { name: 'twitter:description', content: SEO.description }],
  ['meta', { name: 'twitter:image', content: SOCIAL_IMAGE_URL }],
  ['meta', { name: 'twitter:image:alt', content: SOCIAL_IMAGE_ALT }],
  ['link', { rel: 'canonical', href: SEO.canonical }],
  ['link', { rel: 'alternate', type: 'text/markdown', href: LANDING_MARKDOWN_URL }],
];

export const STRUCTURED_DATA = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': 'https://okmaia.com/#organization',
    name: MARKETING_NAME,
    legalName: COMPANY_NAME,
    taxID: COMPANY_CNPJ,
    url: LANDING_URL,
    logo: 'https://okmaia.com/logo.png',
    sameAs: SAME_AS_LINKS,
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'sales',
      email: COMPANY_EMAIL,
      url: SEO.contactUrl,
      availableLanguage: 'pt-BR',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: SEO.title,
    description: SEO.description,
    url: LANDING_URL,
    inLanguage: 'pt-BR',
    dateModified: LAST_MODIFIED,
    about: {
      '@type': 'Thing',
      name: 'Mentoria digital no WhatsApp',
    },
    publisher: {
      '@id': 'https://okmaia.com/#organization',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: MARKETING_NAME,
    url: LANDING_URL,
    inLanguage: 'pt-BR',
    dateModified: LAST_MODIFIED,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'MAIA Mentoria Digital',
    applicationCategory: 'EducationalApplication',
    operatingSystem: 'WhatsApp',
    description: SEO.description,
    url: LANDING_URL,
    provider: {
      '@type': 'Organization',
      name: COMPANY_NAME,
      taxID: COMPANY_CNPJ,
      url: LANDING_URL,
    },
    dateModified: LAST_MODIFIED,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQS.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
    dateModified: LAST_MODIFIED,
  },
];

function escapeAttribute(value) {
  return String(value).replaceAll('&', '&amp;').replaceAll('"', '&quot;');
}

/** Head da landpage servida como HTML estático (crawlers e primeiro paint). */
export function renderHeadTags() {
  const tags = META_TAGS.map(([tagName, attributes]) => {
    const serialized = Object.entries(attributes)
      .map(([key, value]) => `${key}="${escapeAttribute(value)}"`)
      .join(' ');
    return `<${tagName} data-maia-static="true" ${serialized}>`;
  });

  tags.push(`<link id="${FONT_ID}" rel="stylesheet" href="${escapeAttribute(FONT_HREF)}">`);
  tags.push(
    `<script data-maia-static="true" type="application/ld+json">${JSON.stringify(
      STRUCTURED_DATA
    ).replaceAll('<', '\\u003c')}</script>`
  );

  return tags.join('\n    ');
}
